export default __webpack_public_path__ + "static/media/wheelIconMobile.0928d13e.svg";